import { Row } from 'app/design/primitives/box';
import { getLocalCacheForImage } from 'app/design/primitives/image';
import ImageViewerModal from 'app/design/primitives/image-viewer-modal';
import { Thumbnail } from 'app/design/primitives/thumbnail';
import { type Profile } from 'app/network/profile';
import React from 'react';
import { Pressable, View } from 'react-native';
import { theme } from './shared';
import { ProfileIdentity } from './profile-identity';
import { ProfileHeroSkeleton } from './profile-hero-skeleton';

export function ProfileHero({
  badge,
  isImageViewerModalOpen,
  isUnavailable,
  onCloseImage,
  onOpenAmbassador,
  onOpenImage,
  profile,
  showSuperPartageur,
  trustPoints,
  viewedProfileIsAmbassador,
}: {
  badge: React.ReactElement;
  isImageViewerModalOpen: boolean;
  isUnavailable: boolean;
  onCloseImage: () => void;
  onOpenAmbassador: () => void;
  onOpenImage: () => void;
  profile: Profile | undefined;
  showSuperPartageur: boolean;
  trustPoints?: number;
  viewedProfileIsAmbassador: boolean;
}) {
  if (!profile) return <ProfileHeroSkeleton />;
  return (
    <Row alignItems="center" style={{ marginBottom: theme.spacing['spacing.general.x3'] }}>
      <View style={{ height: 88, width: 88 }}>
        <Pressable onPress={onOpenImage}>
          <Thumbnail height={88} source={{ uri: profile.picture }} useOwnCache badge={badge} />
        </Pressable>
        {profile.picture ? (
          <ImageViewerModal
            imageUrls={[{ url: getLocalCacheForImage(profile.picture) ?? profile.picture }]}
            onClose={onCloseImage}
            open={isImageViewerModalOpen}
          />
        ) : null}
      </View>
      <ProfileIdentity
        isUnavailable={isUnavailable}
        onOpenAmbassador={onOpenAmbassador}
        profile={profile}
        showSuperPartageur={showSuperPartageur}
        trustPoints={trustPoints}
        viewedProfileIsAmbassador={viewedProfileIsAmbassador}
      />
    </Row>
  );
}
